import type { ApolloClient } from '@apollo/client';
import {
  GET_GATE_RENDERER_DATA,
  GET_GATE_RENDERER_DATA_FOR_METRICS_VIEW,
} from '../graphql/queries/getGateRendererData';
import { GET_MOVEMENT_DATA } from '../graphql/queries/getMovementRendererData';
import { GET_ACTIVE_GATE_MOVEMENTS } from '../graphql/queries/getActiveGateMovements';

export const refreshActiveGateData = async <TCacheShape extends object>(
  client: ApolloClient<TCacheShape>,
) => {
  try {
    await client.refetchQueries({
      include: [
        GET_GATE_RENDERER_DATA,
        GET_GATE_RENDERER_DATA_FOR_METRICS_VIEW,
        GET_MOVEMENT_DATA,
        GET_ACTIVE_GATE_MOVEMENTS,
      ],
    });
  } catch (error) {
    console.error(
      '[refreshActiveGateData] no se pudieron refrescar los datos de la compuerta',
      error,
    );
  }
};

export const refreshActiveGateDataWhenVisible = <TCacheShape extends object>(
  client: ApolloClient<TCacheShape>,
  visibilityState: DocumentVisibilityState,
) => (visibilityState === 'visible' ? refreshActiveGateData(client) : Promise.resolve());
